import React from 'react';

import { Col, Container, Row } from 'react-bootstrap';

import './styles.scss';

interface IFullScreenModalProps {
    className?: string;
}

export const FullScreenModal = ({
    className,
    children,
}: React.PropsWithChildren<IFullScreenModalProps>) => {

    return (
        <div className={`${className || ''} FullScreenModal`}>
            <Container>
                <Row>
                    <Col className="col-xxl-4 offset-xxl-4" lg={{span: 6, offset: 3}} md={{span: 8, offset: 2}}>
                        {children}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

FullScreenModal.defaultProps = {
    close: true
};